"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
var _bcmKunrenActions = require("../bcmKunrenActions");
var _KunrenInfoField = _interopRequireDefault(require("../common/components/KunrenInfoField"));
var _Consts = require("../common/consts/Consts");
var _MedplanField = _interopRequireDefault(require("./components/MedplanField"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var Yup = _interopRequireWildcard(require("yup"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const FieldSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});
const ActionsButton = (0, _styles.styled)(_CButton.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    marginLeft: theme.spacing(2)
  };
});
const ActionsContainer = (0, _styles.styled)('div')({
  textAlign: 'right'
});

/**
 * 訓練中期計画登録画面
 */
const KunrenMedplanEntry = props => {
  const {
    intl,
    callAPI,
    goMain,
    checkDirty,
    setDirty,
    setEntries,
    setContent,
    openConfirm,
    openInfoBar,
    setEntry,
    kunrenInfo,
    entries
  } = props;
  const [isCustomCheck, setIsCustomCheck] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (kunrenInfo) {
      callAPI(_APIs.BCM_KUNREN_MEDPLAN, kunrenInfo).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntries(response.data);
        }
      });
    }
    window.scrollTo(0, 0);
  }, [callAPI, kunrenInfo, setEntries]);
  const schema = (0, _react.useMemo)(() => {
    const lengthMsg = n => intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
    }, {
      0: n
    });
    return Yup.object({
      submitRequiredFlag: Yup.boolean().nullable(),
      kunrenYear: Yup.string().nullable(),
      // 対象リスク：登録時（submitRequiredFlag=true）のみ、当年度(kunrenYear)に1件以上の選択を必須
      checkStatusList: Yup.array().of(Yup.object({
        notes: Yup.string().max(10, lengthMsg(10)).nullable()
      })).nullable().test('tgt-risk-required-for-year', intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_TGTRISK_ERR
      }), function (list) {
        const {
          submitRequiredFlag,
          kunrenYear
        } = this.parent || {};
        if (!submitRequiredFlag) return true;
        if (!Array.isArray(list) || !kunrenYear) return false;
        const yrStr = String(kunrenYear);
        return list.some(item => {
          if (String(item.kunrenNendo) !== yrStr) return false;
          if (item.checkKbn !== _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) return false;
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            return !!(item.notes && String(item.notes).trim() !== '');
          }
          return item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1;
        });
      }),
      medPlanList: Yup.array().of(Yup.object({
        kunrenPurpose: Yup.string().max(1000, lengthMsg(1000)).nullable(),
        notes: Yup.string().max(1000, lengthMsg(1000)).nullable()
      })).nullable()
    });
  }, [intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: {
      submitRequiredFlag: isCustomCheck,
      kunrenYear: entries.kunrenYear,
      checkStatusList: entries.checkStatusList,
      medPlanList: entries.medPlanList
    },
    shape: schema,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit'
  });

  // Redux -> RHF 同期
  (0, _react.useEffect)(() => {
    reset({
      submitRequiredFlag: isCustomCheck,
      kunrenYear: entries.kunrenYear,
      checkStatusList: entries.checkStatusList,
      medPlanList: entries.medPlanList
    }, {
      keepErrors: true,
      keepDirty: true,
      keepTouched: true,
      keepIsSubmitted: true
    });
  }, [entries.kunrenYear, entries.checkStatusList, entries.medPlanList, isCustomCheck, reset]);

  // 送信前の事前処理（登録/一時保存の切替と必須フラグ同期）
  const onClickBeforeSubmit = reg => () => {
    setIsCustomCheck(reg);
    setValue('submitRequiredFlag', reg, {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  const onValid = () => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: isCustomCheck ? _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE : _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
    }), () => {
      const sendData = _objectSpread(_objectSpread({}, entries), {}, {
        procKbn: isCustomCheck ? 'register' : 'temp_save'
      });
      callAPI(_APIs.BCM_KUNREN_MEDPLAN_REGISTER, sendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          if (isCustomCheck) {
            setContent(_bcmKunrenActions.CONTENTS.MEDPLAN_RESULT);
          } else {
            setDirty(false);
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_TEMP_STORE_MESSAGE
            }, {
              0: intl.formatMessage({
                id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN
              })
            }));
            goMain(true);
          }
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
  };
  const onInvalid = () => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  };

  // Redux＋RHF 同期ヘルパ
  const onChangeList = newList => {
    setDirty(true);
    setEntry('checkStatusList')(newList);
    setValue('checkStatusList', newList, {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_TITLE
    })
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
    data: kunrenInfo,
    hiddenFlg: true
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_MedplanField.default, {
    entries: entries,
    setEntry: key => value => {
      setEntry(key)(value);
      setDirty(true);
    },
    errors: errors,
    setFormValue: setValue,
    setCheckStatusList: onChangeList,
    trigger: () => Promise.resolve(true)
  }))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(ActionsContainer, null, /*#__PURE__*/_react.default.createElement(ActionsButton, {
    onClick: () => checkDirty(() => goMain(false)),
    autoWidth: true,
    negative: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
  })), _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_1 !== entries.kunrenProgressCd && /*#__PURE__*/_react.default.createElement(ActionsButton, {
    onClick: onClickBeforeSubmit(false),
    submit: true,
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TEMP_STORE
  })), /*#__PURE__*/_react.default.createElement(ActionsButton, {
    onClick: onClickBeforeSubmit(true),
    submit: true,
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }))))))));
};
const mapStateToProps = state => ({
  kunrenInfo: state.bcmKunren.kunrenInfo,
  entries: state.bcmKunren.entries,
  medplanErrMsg: state.bcmKunren.medplanErrMsg
});
const mapDispatchToProps = dispatch => {
  return {
    setMedplanErrMsg: key => value => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_MEDPLAN_ERR_MSG](key, value)),
    resetMedplanErrMsg: () => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.RESET_MEDPLAN_ERR_MSG]()),
    goMain: doSearch => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_MAIN](doSearch)),
    setEntry: key => value => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_MEDPLAN_ENTRY](key, value)),
    setEntries: entries => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_MEDPLAN_ENTRIES](entries)),
    setContent: content => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_CONTENT](content)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KunrenMedplanEntry)));